module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst term = ((resourceData || {}).meta || {}).term || {}\nconst showCateringOptions = model.showProjectTermFields\nlet dataINT\nif(showCateringOptions){\nconst projectTermFields = (model || {}).projectTermFields || {}\ndataINT = (projectTermFields[term.projectTermID || -1] || {}).catering === true ? 1 : 0\n}\nlet groupTitle = 'UNKNOWN_DATE'\nif(term.startTS){\ngroupTitle = `#${term.projectTermID} - ${utils.moment(term.startTS).format('DD.MM.YYYY')}`\n}\n%>\n<tbody>\n<tr>\n<td colspan=\"<%= config.maxNrOfColumns %>\">\n<%= groupTitle %>\n<%\nif(showCateringOptions){\n%>\n<div class=\"catering\">\ninkl. Catering\n<%- include('../../../../base/form/fields/toggle', { model: { dataINT, fieldCode: `catering_${term.projectTermID}`, atom: { dataType: 'boolean' }, config: { strict: true }}}) %>\n</div>\n<%\n}\n%>\n</td>\n</tr>\n</tbody>"
  , __filename = "components/templates/crew/timeRecordings/table/groupRow.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const term = ((resourceData || {}).meta || {}).term || {}
const showCateringOptions = model.showProjectTermFields
let dataINT
if(showCateringOptions){
const projectTermFields = (model || {}).projectTermFields || {}
dataINT = (projectTermFields[term.projectTermID || -1] || {}).catering === true ? 1 : 0
}
let groupTitle = 'UNKNOWN_DATE'
if(term.startTS){
groupTitle = `#${term.projectTermID} - ${utils.moment(term.startTS).format('DD.MM.YYYY')}`
}

    ; __line = 13
    ; __append("\n<tbody>\n<tr>\n<td colspan=\"")
    ; __line = 16
    ; __append(escapeFn( config.maxNrOfColumns ))
    ; __append("\">\n")
    ; __line = 17
    ; __append(escapeFn( groupTitle ))
    ; __append("\n")
    ; __line = 18
    ; 
if(showCateringOptions){

    ; __line = 20
    ; __append("\n<div class=\"catering\">\ninkl. Catering\n")
    ; __line = 23
    ; __append( include('../../../../base/form/fields/toggle', { model: { dataINT, fieldCode: `catering_${term.projectTermID}`, atom: { dataType: 'boolean' }, config: { strict: true }}}) )
    ; __append("\n</div>\n")
    ; __line = 25
    ; 
}

    ; __line = 27
    ; __append("\n</td>\n</tr>\n</tbody>")
    ; __line = 30
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/timeRecordings/table/groupRow.ejs

}